module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.filtered_groups.length),
      expression: "filtered_groups.length"
    }],
    staticClass: "notes-list ui segments"
  }, _vm._l((_vm.filtered_groups), function(group) {
    return _c('div', {
      staticClass: "ui segment item",
      class: {
        pinned: group.pinned
      }
    }, [(_vm.showLabel && group.no) ? _c('div', {
      staticClass: "no",
      domProps: {
        "textContent": _vm._s(group.no)
      },
      on: {
        "click": function($event) {
          _vm.label_click(group)
        }
      }
    }) : _vm._e(), (group.pinned) ? _c('div', {
      staticClass: "pinned-icon"
    }, [_c('i', {
      staticClass: "icon pin"
    })]) : _vm._e(), _c('div', {
      staticClass: "notes",
      on: {
        "click": function($event) {
          _vm.open(group)
        }
      }
    }, _vm._l((group.notes), function(item) {
      return _c('div', {
        staticClass: "item",
        class: {
          semitrans: item.state
        }
      }, [_c('div', {
        staticClass: "time"
      }, [_vm._v(_vm._s(_vm.$formatters.date.to_date_short(item.time_modified)))]), (item.tags && item.tags.length) ? _c('div', {
        staticClass: "tags"
      }, _vm._l((item.tags), function(tag) {
        return _c('div', {
          staticClass: "tag",
          style: ({
            background: _vm.tag_color(tag)
          })
        }, [_vm._v(_vm._s(tag))])
      })) : _vm._e(), _c('pre', {
        staticClass: "content",
        class: {
          checked: item.state
        },
        domProps: {
          "textContent": _vm._s(_vm.note_format(item))
        }
      }), (item._modifier) ? _c('div', {
        staticClass: "operator"
      }, [_vm._v(_vm._s(' - ' + item._modifier))]) : _vm._e()])
    }))])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-542a440a","hasScoped":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/src/components/basic/NotesList.vue
// module id = 329
// module chunks = 0